import RemoveButton from 'components/FrictionlessCheckout/Payment/PaymentMethodList/CreditCardsList/RemoveButton/RemoveButton';

export default RemoveButton;
